import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/teams/(teams-page)/@content/TeamsContent.tsx");
